import Header from "./Header";
import SidebarIcons from "./SidebarIcons";
import Sidebar from "./Sidebar";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import dashlogo from "../assets/img/dashbarlogo.png";
// import downloadlogo from "../assets/img/downicon.png";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import { IconButton } from "@mui/material";
import searchIcon from "../assets/img/searchIcon.png";
import DynamicTable from "./common/DynamicTable";
import ClearIcon from "@mui/icons-material/Clear";
import UpdateActionPopUp from "./common/UpdateActionPopUp";
import useGetClientId from "../hooks/useGetClientId";
import StatusPill from "./common/StatusPill";
import Toaster from "./common/Toaster";
import http from "../api/server";
import DatePicker from "react-multi-date-picker";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import {
  GET_ACTION_DETAILS,
  GET_PROPERTY_INFO_WITH_MASTER,
  GET_PROPERTIES_LIST,
} from "../api/apiPath";
import LoadingComponent from "./common/LoadingComponent";

const ActionRemediation = () => {
  const { clientNameParam } = useParams();
  const STORAGE_KEY = "toolbarValue";
  const [loading, setLoading] = useState(true);
  const clientObj = useGetClientId();
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [dash, setDash] = useState("");
  const [propertiesList, setPropertiesList] = useState([]);
  const [actionIdList, setActionidList] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);

  const navigate = useNavigate();

  const gotoDashBoard = (rowData, field) => {
    let pathTemplate;

    if (field === "view") {
      pathTemplate = "/client/:clientNameParam/viewAction";
    } else {
      pathTemplate = "/client/:clientNameParam/viewAction";
    }

    const params = {
      clientNameParam: clientNameParam,
    };

    const fullPath = generatePath(pathTemplate, params);

    navigate(fullPath, {
      state: {
        selectedRow: rowData,
      },
    });
  };

  const { userObj } = useSelector((state) => state.user);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [rows, setRows] = useState([]);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  useEffect(() => {
    if (!userObj || !userObj?.token) {
      navigate(
        generatePath("/client/:clientNameParam", {
          clientNameParam,
        }),
        { replace: true, state: { from: "/ClientBranding" } }
      );
    }
  }, [userObj, navigate]);

  useEffect(() => {
    if (!selectedIds.length) {
      setSelectedRows([]);
      return;
    }

    const mapped = rows.filter((row) => selectedIds.includes(row.id));

    setSelectedRows(mapped);
  }, [selectedIds, rows]);

  const tableColumns = [
    {
      field: "siteName",
      height: 50,
      minWidth: 200,
      headerName: "SITE NAME",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "address",
      headerName: "ADDRESS",
      width: 150,
      height: 90,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "actionId",
      headerName: "ID",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "priority",
      headerName: "PRIORITY",
      width: 150,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => <StatusPill status={params.value} />,
    },
    {
      field: "actionRequired",
      headerName: "ACTION REQUIRED",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      width: 350,
      minWidth: 350,
      flex: 1,

      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            paddingTop: "8px",
            paddingBottom: "8px",
            lineHeight: "1.4",
          }}
        >
          {params.value}
        </div>
      ),
    },

    {
      field: "elementAffected",
      width: 160,
      height: 50,
      headerName: "ELEMENT AFFECTED",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "dueDate",
      width: 210,
      height: 50,
      headerName: "DUE DATE",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 210,
      flex: 1,
    },
    {
      field: "completedOn",
      width: 160,
      height: 50,
      headerName: "COMPLETED ON",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "completedBy",
      width: 160,
      height: 50,
      headerName: "COMPLETED BY",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "status",
      width: 180,
      height: 50,
      headerName: "STATUS",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 1,
      renderCell: (params) => <StatusPill status={params.value} />,
    },
    {
      field: "Actions",
      headerName: "Actions",
      width: 90,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 90,
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <i
              className="fa-solid fa-eye fa-lg"
              title="View"
              style={{ cursor: "pointer", justifyItems: "center" }}
              //
              onClick={() => {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(toolbar));
                gotoDashBoard(params.row, "view");
              }}
            ></i>
          </>
        );
      },
    },
  ];

  const [toolbar, setToolBar] = useState({
    searchText: "",
    actionId: "",
    priority: "",
    status: "",
    dueDate: "",
    dueFrom: "",
    dueTo: "",
    propertyId: "",
    pageSize: 100,
  });

  const TOOLBAR_INITIAL = {
    searchText: "",
    actionId: "",
    priority: "",
    status: "",
    dueDate: "",
    dueFrom: "",
    dueTo: "",
    propertyId: "",
    pageSize: 100,
  };

  const isAnyFilterApplied =
    toolbar.searchText !== "" ||
    toolbar.actionId !== "" ||
    toolbar.priority !== "" ||
    toolbar.status !== "" ||
    toolbar.dueFrom !== "" ||
    toolbar.dueTo !== "" ||
    toolbar.propertyId !== "";

  useEffect(() => {
    if (!clientObj?.clientId) return;

    const fetchPropertiesList = async () => {
      try {
        const response = await http.get(
          GET_PROPERTIES_LIST + `?clientId=${clientObj?.clientId}`
        );
        if (response.status === 200) {
          console.log(response);
          setPropertiesList(response?.data);
          const first = response?.data?.[0];
          setSelectedSite(first);
          setToolBar((prev) => ({
            ...prev,
            propertyId: "",
          }));

          const existing = localStorage.getItem(STORAGE_KEY);

          localStorage.removeItem(STORAGE_KEY);
          if (existing !== null) {
            const parsed = JSON.parse(existing);
            console.log("storage", parsed);
            setToolBar(parsed);
            fetchProfileDetails(first, parsed); // reload table
          } else {
            fetchProfileDetails(first);
          }
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchPropertiesList();
  }, [clientObj?.clientId]);

  const fetchProfileDetails = async (site, existingToolbar) => {
    try {
      setLoading(true);
      let toolbarvalues;
      if (existingToolbar) {
        toolbarvalues = existingToolbar;
      } else {
        toolbarvalues = toolbar;
      }
      const payload = {
        clientId: clientObj?.clientId,
        // propertyMasterId:
        //   toolbar.propertyId === ""
        //     ? site?.propertyMasterId
        //     : toolbar.propertyId,
        // clientId: "BD44F9AC-6A4A-4073-866C-A8CF840C4176",
        // propertyMasterId:"AA8329DA-4687-4A73-8DD7-E0DF467011C7",
        propertyMasterId: toolbarvalues.propertyId?.trim() || null,
        searchText:
          toolbarvalues.searchText === "" ? null : toolbarvalues.searchText,
        idSearch: toolbarvalues.actionId === "" ? null : toolbarvalues.actionId,
        priority: toolbarvalues.priority === "" ? null : toolbarvalues.priority,
        status: toolbarvalues.status === "" ? null : toolbarvalues.status,
        dueFrom: toolbarvalues.dueFrom === "" ? null : toolbarvalues.dueFrom,
        dueTo: toolbarvalues.dueTo === "" ? null : toolbarvalues.dueTo,
        pageNumber: 1,
        pageSize: toolbarvalues.pageSize,
      };

      const res = await http.post(GET_ACTION_DETAILS, payload);

      const data = res.data;
      setDash(data?.dashboard);
      if (data?.items?.length > 0) {
        const actionIdRef = await fetchActionItemIdFromProperty(
          toolbar.propertyId === ""
            ? site?.propertyMasterId
            : toolbar.propertyId,
          data.items[0].inspectionReferenceNumber
        );
        const mappedRows = data?.items?.map((item, index) => ({
          id: null || index,
          actionId: actionIdRef.filter(
            (x) => x.id === item.complianceCheckMasterID
          )[0].actionId,
          siteName: item.propertyName,
          address: item.propertyLocation,
          priority: item.priority,
          actionRequired: item.remediation,
          elementAffected: item.doorLocation,
          dueDate: item.dueDate
            ? new Date(item.dueDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })
            : "",
          completedOn: item.createdOn
            ? new Date(item.createdOn).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })
            : "",
          completedBy: item.createdBy,
          status: item.status || "Not Available",
          postalcode: item.postalCode,
          country: item.cityId,
          inspctiondate: item.inspectionDate
            ? new Date(item.inspectionDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })
            : "",
          inspectionby: item.inspectors,
          approveby: item.approvers,
          approvedon: item.approvalDate
            ? new Date(item.approvalDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })
            : "",

          compcheckid: item.complianceCheckID,
          inspdoorid: item.inspectedDoorId,
          comcheckmaster: item.complianceCheckMasterID,
        }));

        setRows(mappedRows);
      } else {
        setRows([]);
      }
    } catch (err) {
      console.error(err);
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString:
          err?.response?.data?.message ||
          err?.message ||
          "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };
  const stripTime = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const fetchActionItemIdFromProperty = async (
    propertyMasterId,
    inspectionReferenceNumber
  ) => {
    try {
      const response = await http.get(
        GET_PROPERTY_INFO_WITH_MASTER +
          propertyMasterId +
          "?InspectionReferenceNumber=" +
          inspectionReferenceNumber
      );

      if (response.status == 200) {
        const mappedRows = response?.data?.doorComplainceCheckMasters?.map(
          (item) => ({
            id: item.doorComplainceCheckMasterId,
            actionId: item.actionItemId,
          })
        );
        setActionidList(mappedRows);
        return mappedRows;
      }
    } catch (error) {
      console.error("Property API error:", error);
      return null;
    }
  };

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={closeButton}
      />
      <LoadingComponent loading={loading} />
      {userObj && (
        <div className="dashboard_body_main">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}
          <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2 ">
            <div className="col-12 col-sm-12 col-lg-12 mb-3">
              <div className="d-flex justify-content-between align-items-center w-100 mt-3">
                <h3 className="justifyStart fw-semibold mb-0">Actions Plan</h3>
              </div>

              <div
                className="card mt-4 p-3 rounded-4 mb-4 orange-box d-flex gap-3 flex-row align-items-center justify-content-between"
                style={{ height: "9.5rem" }}
              >
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-evenly text-center py-4">
                    <div>
                      <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                        {dash.totalOpenActions}
                      </h1>
                      <p className="fw-semibold mb-0">Total Open Actions</p>
                    </div>
                    <div className="col-6 col-sm-4 col-lg-2 mb-1">
                      <img src={dashlogo} alt="Inspector" height="100" />
                    </div>
                    <div>
                      <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                        {dash.overdueActions}
                      </h1>
                      <p className="fw-semibold mb-0">Overdue Actions</p>
                    </div>
                    <div>
                      <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                        {dash.pendingReview}
                      </h1>
                      <p className="fw-semibold mb-0">Pending Review</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 mb-3">
                <h3 className="fw-semibold  mb-0 text-start ">Door Surveys</h3>
                <div className="row py-3 align-items-center g-2">
                  <div className="col d-flex flex-wrap align-items-center gap-2">
                    <div className="custom_toolbar_search col-12 col-sm-6 col-md-3">
                      <img src={searchIcon} alt="search" />
                      <input
                        type="text"
                        className="form-control custom_toolbar_control"
                        placeholder="Search actions..."
                        value={toolbar.searchText}
                        onChange={(e) =>
                          setToolBar({ ...toolbar, searchText: e.target.value })
                        }
                      />
                    </div>

                    <div className="col-12 col-sm-6 col-md-3">
                      <select
                        className="form-select custom_toolbar_control"
                        value={toolbar.propertyId}
                        onChange={(e) =>
                          setToolBar({ ...toolbar, propertyId: e.target.value })
                        }
                      >
                        <option value="">Site Name</option>
                        {propertiesList.length > 0 &&
                          propertiesList?.map((data) => (
                            <option
                              key={data?.propertyMasterId}
                              value={data?.propertyMasterId}
                            >
                              {data.name}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-12 col-sm-6 col-md-3">
                      <select
                        className="form-select custom_toolbar_control"
                        value={toolbar.actionId}
                        onChange={(e) =>
                          setToolBar({ ...toolbar, actionId: e.target.value })
                        }
                      >
                        <option value="">ID</option>
                        {actionIdList.length > 0 &&
                          actionIdList?.map((data) => (
                            <option key={data?.actionId} value={data?.actionId}>
                              {data.actionId}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-12 col-sm-6 col-md-3">
                      <select
                        className="form-select custom_toolbar_control"
                        value={toolbar.priority}
                        onChange={(e) =>
                          setToolBar({ ...toolbar, priority: e.target.value })
                        }
                      >
                        <option value="">Priority</option>
                        <option value="Critical">Critical</option>
                        <option value="High">High</option>
                        <option value="Medium">Medium</option>
                        <option value="Low">Low</option>
                      </select>
                    </div>

                    <div className="col-12 col-sm-6 col-md-3">
                      <select
                        className="form-select custom_toolbar_control"
                        value={toolbar.status}
                        onChange={(e) =>
                          setToolBar({ ...toolbar, status: e.target.value })
                        }
                      >
                        <option value="">Status</option>
                        <option value="Pending">Pending</option>
                        <option value="Completed">Completed</option>
                      </select>
                    </div>

                    <div className="col-12 col-sm-6 col-md-3">
                      <DatePicker
                        className=""
                        value={dateRange}
                        onChange={(range) => {
                          const [start, end] = range || [];

                          setDateRange(range || [null, null]);
                          setToolBar((prev) => ({
                            ...prev,
                            dueFrom: start ? stripTime(start) : null,
                            dueTo: end ? stripTime(end) : null,
                          }));
                        }}
                        range
                        format="DD-MM-YYYY"
                        placeholder="Select date range"
                        plugins={[
                          <Toolbar
                            key={1}
                            position="bottom"
                            sort={["deselect", "close", "today"]}
                          />,
                        ]}
                        style={{ width: "100%" }}
                      />
                    </div>

                    {isAnyFilterApplied && (
                      <IconButton
                        title="Clear Filters"
                        onClick={() => {
                          setToolBar({
                            searchText: "",
                            actionId: "",
                            priority: "",
                            status: "",
                            dueDate: "",
                            dueFrom: "",
                            dueTo: "",
                            propertyId: "",
                          });
                          fetchProfileDetails(selectedSite, TOOLBAR_INITIAL);
                        }}
                      >
                        <ClearIcon sx={{ color: "#717186" }} fontSize="small" />
                      </IconButton>
                    )}
                  </div>

                  <div className="col-auto d-flex align-items-center gap-3">
                    {/* <img
                      src={downloadlogo}
                      alt="download"
                      style={{ cursor: "pointer" }}
                    /> */}
                    <button
                      type="button"
                      className="btn btn-dark fw-bold"
                      onClick={() => fetchProfileDetails(selectedSite)}
                    >
                      Get search Rows(s)
                    </button>

                    <button
                      type="button"
                      className="btn btn-dark fw-bold"
                      onClick={() => {
                        localStorage.setItem(
                          STORAGE_KEY,
                          JSON.stringify(toolbar)
                        );
                        setShowUpdateModal(true);
                      }}
                      disabled={selectedIds.length === 0 ? true : false}
                    >
                      <i className="fa fa-edit me-2"></i>
                      Update Action(s)
                    </button>
                    {showUpdateModal && (
                      <UpdateActionPopUp
                        show={showUpdateModal}
                        headingText="Update Action(s)"
                        cancelText="Cancel"
                        submitText="Update"
                        selectedRows={selectedRows}
                        onCancel={() => {
                          setShowUpdateModal(false);
                        }}
                        onSuccess={() => {
                          setLoading(true);
                          const existing = localStorage.getItem(STORAGE_KEY);
                          console.log("storage", existing);
                          if (existing !== null) {
                            const parsed = JSON.parse(existing);
                            setToolBar(parsed);

                            fetchProfileDetails(selectedSite, parsed); // reload table
                          }
                          setShowUpdateModal(false);
                        }}
                      />
                    )}
                  </div>
                </div>

                <div className="inspection-table pt-2">
                  <DynamicTable
                    columnsValue={tableColumns}
                    tableData={rows}
                    showSelectAll={true}
                    pageSize={10}
                    rowHeight={90}
                    setSelectedIds={setSelectedIds}
                    pageSizeOptions={[
                      100,
                      150,
                      200,
                      { value: -1, label: "All" },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ActionRemediation;
